import { fetchWrapper } from "@/helpers/fetch-wrapper";

const API_URL = process.env.VUE_APP_SERVER_URL;

export const getPolicy = () => fetchWrapper.get(`${API_URL}/api/policies`);
